import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

// Ionic Modules
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

// Custom Modules
import { CoreModule } from './@core/core.module';
import { BusinessModule } from './@business/business.module';

// Routes
import { AppRoutingModule } from './app-routing.module';

// Declared Components
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FontAwesomeModule,
        IonicModule.forRoot({
            backButtonIcon: 'chevron-back-outline',
            swipeBackEnabled: true
        }),
        CoreModule.forRoot(),
        BusinessModule.forRoot(),
    ],
    providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
    bootstrap: [AppComponent]
})
export class AppModule {}
